import ActivityFeed from '../../components/activity-feed/ActivityFeed'
import AppLayout from '../../components/app-layout/AppLayout'
import WeeklyDigestCard from '../../components/weekly-digest-card/WeeklyDigestCard'
import { Header, PageStack, PageSubtitle, PageTitle } from './styled'

const FULL_LIMIT = 200

/**
 * Full-page chronological activity timeline. Shows everything that's
 * happened on the renter's QuickPass — listing imports, price moves,
 * achievement unlocks, onboarding milestone — newest first.
 *
 * @returns {JSX.Element}
 */
const ActivityPage = (): JSX.Element => {
  return (
    <AppLayout contentMaxWidth="standard">
      <PageStack
        initial={{ opacity: 0 }}
        animate={{ opacity: 1, transition: { duration: 0.32 } }}
      >
        <Header>
          <PageTitle>Activity</PageTitle>
          <PageSubtitle>
            Every price drop, listing import, and milestone, in order. The
            things QuickPass quietly does for you.
          </PageSubtitle>
        </Header>

        <WeeklyDigestCard ctaPathOverride="/saved-listings" />

        <ActivityFeed limit={FULL_LIMIT} showEmptyState={true} />
      </PageStack>
    </AppLayout>
  )
}

export default ActivityPage
